import styled from "styled-components";
import { FieldSet, FormSelect } from "../../../../../App/Common/Components/FormComponents";
import { IDividerSettings } from "ts/components/course-author/types";
import { FormContainer } from "../../../../pages/CourseAuthor/FormElements";
import { ColorFieldSet, SpacerInput } from "./SpacerPart.styles";

export const FlexFormContainer = styled(FormContainer as any)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  gap: 3rem;
`;

type DividerProps = Omit<IDividerSettings["settings"], "style"> & {
  dividerStyle: IDividerSettings["settings"]["style"];
};

export const Divider = styled.span<DividerProps>`
  display: block;
  width: 90%;
  color: ${props => props.color};
  margin-top: ${props => props.marginTop}px;
  margin-bottom: ${props => props.marginBottom}px;
  border-style: ${props => props.dividerStyle};
  border-width: 0 0 ${props => props.thickness}px 0;
`;

export const SelectorFieldSet = styled(FieldSet)`
  color: ${({ theme }) => theme.colors.darkgrey4};
  width: 10em;
  min-width: 3em;
  height: 3.5em;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
`;

export const DividerFormSelect = styled(FormSelect)`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.lightgrey3};
  margin: 0;
  text-transform: none;
  font-weight: normal;
  outline: none;
  padding: 0 0.5em 0.5em 1em;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: 90% 35%;
  background-size: 1em;
`;

export const DividerColorFieldSet = styled(ColorFieldSet)`
  margin: 0;
  height: 100%;
  width: auto;
`;

export const DividerInput = styled(SpacerInput)`
  width: 75%;
  margin: 0;
  color: ${({ theme }) => theme.colors.textDarkBlue};

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -moz-appearance: textfield;
    -webkit-appearance: none;
    margin: 0;
  }
`;
